<template>
  <v-container class="pa-3" fluid>
    <div class="text-h4 font-weight-bold">Solicitud de Beneficios</div>
    <div class="text-h5">Pasos para llenar la solicitud:</div>
    <v-row dense>
      <v-col cols="12">
        <v-btn class="btn" @click="irAProductor">1. Datos del Productor</v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn class="btn" @click="irAFincas">2. Fincas a Beneficiar</v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn class="btn" @click="irAProduccion">3. Producciones a Beneficiar</v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn class="btn" @click="irAFamilia">4. Familia beneficiada</v-btn>
      </v-col>

      <!-- Componentes condicionales -->
      <v-col cols="12" v-if="mostrarProductor">
        <Productor />
      </v-col>
      <v-col cols="12" v-if="mostrarFincas">
        <!-- Aqui se añade el evento donde se llama al modalFincas -->
        <Fincas :mostrarModal="mostrarModalFinca"/>
      </v-col>
      <v-col cols="12" v-if="mostrarFamilia">
        <Familia />
      </v-col>
      <v-col cols="12" v-if="mostrarProduccion">
        <Boton />
      </v-col>
    </v-row>   
  </v-container>
</template>

<script>
import Productor from './ProductorB.vue'
import Fincas from './FincasB.vue'
import Familia from './Familia.vue'
import Boton from './BotonProduccion.vue'
import ModalFinca from '@/components/ModalFinca.vue'

export default {
  components: {
    Productor,
    Fincas,
    Familia,
    Boton,
    ModalFinca,
  },
  data() {
    return {
      mostrarProductor: false,
      mostrarFincas: false,
      mostrarFamilia: false,
      mostrarProduccion: false,
      mostrarModalFinca: false,
    }
  },
  methods: {
    irAProductor() {
      this.resetMostrar()
      this.mostrarProductor = true
    },
    irAFincas() {
      this.resetMostrar()
      this.mostrarFincas = true
      this.mostrarModalFinca = true
    },
    irAFamilia() {
      this.resetMostrar()
      this.mostrarFamilia = true
    },
    irAProduccion() {
      this.resetMostrar()
      this.mostrarProduccion = true
    },
    resetMostrar() {
      this.mostrarProductor = false
      this.mostrarFincas = false
      this.mostrarFamilia = false
      this.mostrarProduccion = false
    },
  },
}
</script>

<style scoped>
.text-h5 {
  margin-bottom: 10px;
}
.btn {
  justify-content: flex-start !important;
  text-align: left;
  padding-left: 16px;
  width: 100%;
}
</style>
